module.exports = __webpack_public_path__ + "img/button-icon.6cd188e6.svg";